import ClaimDetailsInfo from './ClaimDetailsInfo';

export default ClaimDetailsInfo;
